import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
  const [nickname, setNickname] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userType, setUserType] = useState("student");

  const handleRegister = async () => {
    // 입력값 검증
    if (nickname.trim() === "") {
      alert("닉네임을 입력해주세요.");
      return;
    }

    if (password.length !== 4 || !/^\d+$/.test(password)) {
      alert("비밀번호는 4자리 숫자여야 합니다.");
      return;
    }

    if (password !== confirmPassword) {
      alert("비밀번호가 일치하지 않습니다.");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CHAT_SERVER_URL}/member/sign-up`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: nickname,
            password: password,
            role: userType, // 'student' 또는 'parent'가 전송됨
          }),
        }
      );

      if (response.ok) {
        alert("회원가입이 완료되었습니다.");
        navigate("/");
      } else {
        const errorData = await response.json();
        alert(errorData.message || "회원가입에 실패했습니다.");
      }
    } catch (error) {
      console.error("회원가입 에러:", error);
      alert("회원가입 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-50">
      <div className="bg-white shadow-lg flex flex-col items-center justify-center gap-4 p-8 rounded-xl w-[400px]">
        <div className="w-full text-center mb-2">
          <h1 className="text-2xl font-bold text-blue-600">회원가입</h1>
          <p className="text-gray-500 text-sm mt-1">
            Book Agent에 오신 것을 환영합니다.
          </p>
        </div>

        <div className="w-full bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-gray-700 mb-2">사용자 유형</p>
          <div className="flex gap-6">
            <label
              className="flex-1 flex items-center justify-center p-3 border rounded-lg cursor-pointer transition-all hover:border-blue-500 hover:bg-blue-50"
              style={{
                borderColor: userType === "student" ? "#2563eb" : "#e5e7eb",
                backgroundColor: userType === "student" ? "#eff6ff" : "white",
              }}
            >
              <input
                type="radio"
                name="userType"
                value="student"
                checked={userType === "student"}
                onChange={(e) => setUserType(e.target.value)}
                className="hidden"
              />
              <span
                className={`font-medium ${
                  userType === "student" ? "text-blue-600" : "text-gray-600"
                }`}
              >
                학생
              </span>
            </label>
            <label
              className="flex-1 flex items-center justify-center p-3 border rounded-lg cursor-pointer transition-all hover:border-blue-500 hover:bg-blue-50"
              style={{
                borderColor: userType === "parent" ? "#2563eb" : "#e5e7eb",
                backgroundColor: userType === "parent" ? "#eff6ff" : "white",
              }}
            >
              <input
                type="radio"
                name="userType"
                value="parent"
                checked={userType === "parent"}
                onChange={(e) => setUserType(e.target.value)}
                className="hidden"
              />
              <span
                className={`font-medium ${
                  userType === "parent" ? "text-blue-600" : "text-gray-600"
                }`}
              >
                학부모
              </span>
            </label>
          </div>
        </div>

        <div className="w-full space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              닉네임
            </label>
            <input
              type="text"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              placeholder="닉네임을 입력하세요"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              비밀번호
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              maxLength={4}
              placeholder="비밀번호 4자리 숫자"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              비밀번호 확인
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              maxLength={4}
              placeholder="비밀번호 확인"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        <button
          onClick={handleRegister}
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 mt-4 font-medium"
        >
          가입하기
        </button>

        <div className="text-center mt-2">
          <button
            onClick={() => navigate("/")}
            className="text-gray-500 hover:text-gray-700 underline text-sm"
          >
            돌아가기
          </button>
        </div>
      </div>
    </div>
  );
};

export default Register;
